import CurrencyCircleIcon from "@shared/svg/currency-circle.svg?react";
import CustomFieldIcon from "@shared/svg/custom-field.svg?react";
import HashIcon from "@shared/svg/hash-icon.svg?react";
import CompanyIcon from "@shared/svg/navigation/companies.svg?react";
import { CalendarBlank, User } from "phosphor-react";
import React from "react";

import { OpenFolderIcon } from "~/icons/icons";

const secondary = "shrink-0 text-secondary";

const render = {
  quoteNumber: () => <HashIcon width={16} height={16} className={secondary} />,
  company: () => <CompanyIcon width={16} height={16} className={secondary} />,
  status: () => (
    <CustomFieldIcon width={16} height={16} className={secondary} />
  ),
  totalAmount: () => (
    <CurrencyCircleIcon width={16} height={16} className={secondary} />
  ),
  createdBy: () => <User size={16} className={secondary} />,
  createdAt: () => <CalendarBlank size={16} className={secondary} />,
  validUntilDate: () => <CalendarBlank size={16} className={secondary} />,
  workOrder: () => (
    <OpenFolderIcon
      width={16}
      height={16}
      strokeColor="#748094"
      className="shrink-0"
    />
  ),
  calendar: () => <CalendarBlank size={16} className={secondary} />,
};

/** Shared icons for quotes table headers and column-settings dropdown. */
export const QuoteColumnIcon = {
  quoteNumber: render.quoteNumber(),
  company: render.company(),
  status: render.status(),
  totalAmount: render.totalAmount(),
  createdBy: render.createdBy(),
  createdAt: render.createdAt(),
  validUntilDate: render.validUntilDate(),
  workOrder: render.workOrder(),
};

/** Filter dropdown expects component types (`<item.icon />`). */
export const QuoteFilterIcon = {
  status: render.status,
  company: render.company,
  amount: render.totalAmount,
  createdBy: render.createdBy,
  calendar: render.calendar,
  workOrder: render.workOrder,
};
